import React, { useState } from "react";
import styles from "./styles.module.scss";
import {
  ComputerDetailModal,
  ComputerDetailModalV2,
  ComputersTable,
  DashboardHeader,
  ListOfCards,
} from "./components";
import { ConditionalRenderer } from "components";
export const WolfDashboard = () => {
  const [openDetailModal, setOpenDetailModal] = useState(false);

  function handleOpenModal() {
    setOpenDetailModal(true);
  }
  function handleCloseModal() {
    setOpenDetailModal(false);
  }

  return (
    <div className={styles.container}>
      {/* <DashboardHeader /> */}
      <ListOfCards />
      <ComputersTable setOpenDetailModal={setOpenDetailModal} />
      <ComputerDetailModalV2
        openDetailModal={openDetailModal}
        handleCloseModal={handleCloseModal}
      />
    </div>
  );
};
